module.exports = __webpack_public_path__ + "static/media/tns.72b4978e.jpg";